import type { ProducerStatus } from '../services/adminProducersService';

/** Worst first. Drives the Dashboard tile (spec d17). */
const SEVERITY: readonly ProducerStatus[] = ['failing', 'overdue', 'disabled', 'never-run', 'ok'];

export const PRODUCER_STATUS_LABEL: Record<ProducerStatus, string> = {
  ok: 'OK',
  failing: 'Failing',
  overdue: 'Overdue',
  disabled: 'Disabled',
  'never-run': 'Never run',
};

/** Pill colours: red for failing/overdue (d17), neutral for the rest. */
export const PRODUCER_STATUS_CLASS: Record<ProducerStatus, string> = {
  ok: 'bg-emerald-500/15 text-emerald-300 border-emerald-500/30',
  failing: 'bg-red-500/15 text-red-300 border-red-500/30',
  overdue: 'bg-red-500/15 text-red-300 border-red-500/30',
  disabled: 'bg-zinc-700/40 text-zinc-300 border-zinc-600',
  'never-run': 'bg-zinc-800 text-zinc-400 border-zinc-700',
};

/** Returns the worst status in the list, or null when the list is empty. */
export function worstProducerStatus(statuses: readonly ProducerStatus[]): ProducerStatus | null {
  let worst: ProducerStatus | null = null;
  for (const s of statuses) {
    if (worst === null || SEVERITY.indexOf(s) < SEVERITY.indexOf(worst)) worst = s;
  }
  return worst;
}
